import {
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BModal,
  BFormCheckbox,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    customer_id: Number,
  },
  data() {
    return {
      type: null,
      disabled: false,

      cause: "",
      score_value: 0,
      bon_value: 0,
    };
  },

  methods: {
    changrTransactionType(e) {},

    async changeBonusesPoints() {
      if (this.type == null) {
        this.$notify({
          group: "error",
          title: "کاربر گرامی",
          text: "لطفا نوع تراکنش خود را انتخاب کنید",
          type: "error",
          duration: "5000",
        });
        return false;
      }
      // else if (!this.score_value) {
      //   this.$notify({
      //     group: "error",
      //     title: "کاربر گرامی",
      //     text: "لطفا مقدار امتیاز را وارد کنید",
      //     type: "error",
      //     duration: "5000",
      //   });
      //   return false;
      // }
      // else if (!this.bon_value) {
      //   this.$notify({
      //     group: "error",
      //     title: "کاربر گرامی",
      //     text: "لطفا مقدار بن را وارد کنید",
      //     type: "error",
      //     duration: "5000",
      //   });
      //   return false;
      // }
      else if (!this.cause != "") {
        this.$notify({
          group: "error",
          title: "کاربر گرامی",
          text: "لطفا توضیحات را وارد کنید",
          type: "error",
          duration: "5000",
        });
        return false;
      }
      this.disabled = true;
      try {
        let fd = new FormData();
        fd.append("customer_id", this.customer_id);
        fd.append("type", this.type);
        fd.append("cause", this.cause);
        fd.append("score_value", this.score_value);
        fd.append("bon_value", this.bon_value);
        const response = await this.$axios.post(
          `admin/customers_club/customer/modify-score`,
          fd
        );

        this.$root.notify(response.data.message, "success");
        this.$root.$emit("bv::hide::modal", "customer-bonuses-points");

        this.type = null;
        this.score_value = null;
        this.bon_value = null;
        this.cause = "";
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    },
  },
};
